<template>
    <div class="home">
        <div class="container">
            <div class="card">
                <div class="card-body">
                    <slot></slot> <!-- 将Content全部渲到slot里面 -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContentBase",
}
</script>

<style scoped>
.home {
    padding: 24px 0 28px;
}

.container {
    opacity: 1;
}

.card-body {
    padding: 24px;
}

@media (max-width: 768px) {
    .home {
        padding-top: 16px;
    }

    .card-body {
        padding: 16px;
    }
}
</style>
